import type { MentionProvider } from '@atlaskit/mention';
import { ProjectMentionProvider } from '@atlassian/jira-mention-provider/src/services/project-mention-provider/index.tsx';
import {
	toErrorId,
	toErrorMessage,
} from '@atlassian/jira-project-settings-apps-common/src/types.tsx';
import { famaCatchAndLogFetchError } from '@atlassian/jira-project-settings-apps-common/src/util/catch-and-log-fetch-error.tsx';
import { PACKAGE_NAME } from '../../../../../constants.tsx';

export default class ProjectSettingsProjectMentionProvider
	extends ProjectMentionProvider
	implements MentionProvider
{
	// Instrument the fetch call, so we can report on any errors
	fetchMentions(url: string) {
		return famaCatchAndLogFetchError(
			super.fetchMentions(url),
			PACKAGE_NAME,
			toErrorId('getMentions'),
			toErrorMessage('Failed to fetch mentions for multiline field configuration'),
		);
	}
}
